export const adminBenchmarksEndpoints = {
    base: "/api/admin/benchmarks",
    byId: (jobId: string): string => `/api/admin/benchmarks/${jobId}`,
} as const;

export const adminBenchmarksQueryParams = {
    industry: "industry",
    jobTitle: "job_title",
    perPage: "per_page",
} as const;
